appAddThisWordPress.controller('LanguagesCtrl', function($scope) {

  $scope.fieldName = 'language';

  $scope.languageOptions = [
    {
      value: '',
      display: 'Automatic'
    },
    {
      value: 'af',
      display: 'Afrikaaner'
    },
    {
      value: 'ar',
      display: 'Arabic'
    },
    {
      value: 'zh',
      display: 'Chinese'
    },
    {
      value: 'cs',
      display: 'Czech'
    },
    {
      value: 'da',
      display: 'Danish'
    },
    {
      value: 'nl',
      display: 'Dutch'
    },
    {
      value: 'en',
      display: 'English'
    },
    {
      value: 'fa',
      display: 'Farsi'
    },
    {
      value: 'fi',
      display: 'Finnish'
    },
    {
      value: 'fr',
      display: 'French'
    },
    {
      value: 'ga',
      display: 'Gaelic'
    },
    {
      value: 'de',
      display: 'German'
    },
    {
      value: 'el',
      display: 'Greek'
    },
    {
      value: 'he',
      display: 'Hebrew'
    },
    {
      value: 'hi',
      display: 'Hindi'
    },
    {
      value: 'it',
      display: 'Italian'
    },
    {
      value: 'ja',
      display: 'Japanese'
    },
    {
      value: 'ko',
      display: 'Korean'
    },
    {
      value: 'lv',
      display: 'Latvian'
    },
    {
      value: 'lt',
      display: 'Lithuanian'
    },
    {
      value: 'no',
      display: 'Norwegian'
    },
    {
      value: 'pl',
      display: 'Polish'
    },
    {
      value: 'pt',
      display: 'Portugese'
    },
    {
      value: 'ro',
      display: 'Romanian'
    },
    {
      value: 'ru',
      display: 'Russian'
    },
    {
      value: 'sk',
      display: 'Slovakian'
    },
    {
      value: 'sl',
      display: 'Slovenian'
    },
    {
      value: 'es',
      display: 'Spanish'
    },
    {
      value: 'sv',
      display: 'Swedish'
    },
    {
      value: 'th',
      display: 'Thai'
    },
    {
      value: 'ur',
      display: 'Urdu'
    },
    {
      value: 'cy',
      display: 'Welsh'
    },
    {
      value: 'vi',
      display: 'Vietnamese'
    }
  ];
});